import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuoteModal } from './QuoteModalContext';

const QuoteRoute = () => {
  const navigate = useNavigate();
  const { openQuoteModal, isOpen } = useQuoteModal();
  const hasSeenOpen = useRef(false);

  useEffect(() => {
    openQuoteModal();
  }, [openQuoteModal]);

  useEffect(() => {
    if (isOpen) {
      hasSeenOpen.current = true;
      return;
    }
    if (hasSeenOpen.current) {
      navigate('/', { replace: true });
    }
  }, [isOpen, navigate]);

  return null;
};

export default QuoteRoute;
